import {
	Checkbox,
	FormControl,
	FormErrorMessage,
	Input,
	Textarea,
} from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import {
	AnnouncementStyle,
	type Announcement,
} from "../../types/announcement.types";
import { forwardRef, useImperativeHandle } from "react";

export type AnnouncementFormHandler = {
	valid: () => Promise<boolean>;
	values: () => Partial<Announcement>;
};
type AnnouncementFormProps = { value?: Partial<Announcement> };

const AnnouncementForm = forwardRef<
	AnnouncementFormHandler,
	AnnouncementFormProps
>(({ value }, ref) => {
	const methods = useForm();

	useImperativeHandle(ref, () => ({
		valid: () => {
			return methods.trigger();
		},
		values: () => {
			const updatedFields = methods.getValues();

			return {
				...updatedFields,
				style: updatedFields.style
					? AnnouncementStyle.ERROR
					: AnnouncementStyle.INFO,
			} as Partial<Announcement>;
		},
	}));
	return (
		<FormProvider {...methods}>
			<form>
				<FormControl isInvalid={!!methods.formState.errors.title}>
					<Input
						id="title"
						placeholder="Titre"
						defaultValue={value?.title ?? ""}
						{...methods.register("title", {
							required: "Ce champ est obligatoire",
						})}
					></Input>
					<FormErrorMessage>
						<>{methods.formState.errors?.title?.message}</>
					</FormErrorMessage>
				</FormControl>
				<FormControl isInvalid={!!methods.formState.errors.content} mt={4}>
					<Textarea
						id="content"
						placeholder="Description"
						minH="20rem"
						defaultValue={value?.content ?? ""}
						{...methods.register("content", {
							required: "Ce champ est obligatoire",
						})}
					></Textarea>
					<FormErrorMessage>
						<>{methods.formState.errors?.content?.message}</>
					</FormErrorMessage>
				</FormControl>{" "}
				<FormControl isInvalid={!!methods.formState.errors.style} mt={4}>
					<div className="flex items-center gap-2 border! p-1 rounded-sm border-brand-200! bg-brand-25 text-brand-700">
						<Checkbox
							id="style"
							colorScheme="brand"
							defaultChecked={value?.style === AnnouncementStyle.ERROR}
							{...methods.register("style")}
							className="cursor-pointer"
						/>
						<label htmlFor="style" className="cursor-pointer">
							Message important en rouge
						</label>
					</div>
					<FormErrorMessage>
						<>{methods.formState.errors?.style?.message}</>
					</FormErrorMessage>
				</FormControl>
				<FormControl isInvalid={!!methods.formState.errors.published} mt={4}>
					<div className="flex justify-end items-center gap-2 p-1">
						<label htmlFor="published" className="cursor-pointer">
							Publier cette annonce ?
						</label>
						<Checkbox
							id="published"
							colorScheme="brand"
							defaultChecked={value?.published}
							{...methods.register("published")}
							className="cursor-pointer"
						/>
					</div>
					<FormErrorMessage>
						<>{methods.formState.errors?.published?.message}</>
					</FormErrorMessage>
				</FormControl>
			</form>
		</FormProvider>
	);
});

export default AnnouncementForm;
